<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-23 15:26:10
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-12-04 18:19:09
 * @FilePath: \miniproweb\src\views\RiceData\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="riceBodyBox">
    <div class="myNodty">
      <van-icon name="volume" color="#e7be2b" />暴雨提醒
    </div>
    <!-- <van-notice-bar mode="closeable" class="myNodty">技术是开发它的人的共同灵魂。</van-notice-bar> -->
    <div class="topBox">
      <div class="topLeftBox">
        <div class="imgMyBox">
          <img
            src="https://moodsci.com/mimiproweb/img/center.jpg"
            alt
            style="width:100%;height:100%"
          />
        </div>
        <div class="imgNameBox">小麦</div>
      </div>
      <div class="topRightBox">
        <div class="myCHooseTimeBox">
          <el-select
            v-model="chooseCropTimeData"
            placeholder="请选择"
            size="mini"
            @change="chooseCropTimeDataChange"
          >
            <el-option
              v-for="item in cropListData"
              :key="item.name"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
          <div class="cropTextBox">小麦{{chooseCropTimeDataList.name}}</div>
          <div
            class="cropTextBox"
          >预计时间：{{chooseCropTimeDataList.startMonth}}到{{chooseCropTimeDataList.endMonth}}</div>
        </div>
      </div>
    </div>
    <div class="cropdesBox">
      <div class="desTitle">
        <el-select
          v-model="chooseDocData"
          placeholder="请选择"
          style="width:100%"
          @change="chooseDocDataChange"
        >
          <el-option
            v-for="item in docListData"
            :key="item.title"
            :label="item.title"
            :value="item.title"
          ></el-option>
        </el-select>
      </div>
      <van-empty image="error" description="暂无数据" v-show="isEmp" />
      <div class="desTextBox" v-show="!isEmp">
        <div class="desTextTitle">{{chooseDocDataObj.title}}</div>
        <div class="desTextDes">{{chooseDocDataObj.weatherAnalysis}}</div>
        <div class="desTextDes">{{chooseDocDataObj.expertGuidance}}</div>
        <div class="desTextDes">{{chooseDocDataObj.abstracts}}</div>
        <div class="desTextDes">建议如下农事操作:</div>
        <div style="color:#e7be2b;margin-top:5px">{{chooseDocDataObj.agriculturalAdvice}}</div>

        <div style="margin-top:15px;text-align:right">{{chooseDocDataObj.releaseTime}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      chooseDocData: "",
      chooseDocDataObj: {},
      docListData: [],
      chooseCropTimeData: "",
      chooseCropTimeDataList: "",
      cropListData: [],
      options: [
        {
          value: "农技指导测试1",
          label: "农技指导测试1"
        }
      ],
      value: "农技指导测试1",
      isEmp: false
    };
  },
  created() {
    this.getCropTimeList();
    // this.getNewCropTime();
  },
  methods: {
    chooseDocDataChange(e) {
      this.chooseDocDataObj = this.docListData.find(item => {
        return item.title == e;
      });
    },
    getDocList() {
      this.$axios({
        method: "get",
        url: `http://120.79.183.250:3093/InterfaceServices/AgriculturalTechnologyService/queryAgriculturalTechnologyList?cropCode=010301&growthCode=${this.chooseCropTimeDataList.code}&pageNum=1&pageSize=10`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        console.log(res.data.data.length);
        if (res.data.data.length == 0) {
          this.isEmp = true;
          alert("无数据");
          this.docListData = [];
          this.chooseDocData = "";
          this.chooseDocDataObj = {};
        } else {
          this.isEmp = false;
          this.docListData = res.data.data;
          this.chooseDocData = res.data.data[0].title;
          this.chooseDocDataObj = res.data.data[0];
        }
      });
    },
    getNewCropTime() {
      this.$axios({
        method: "get",
        url: `http://120.79.183.250:3093/InterfaceServices/CropService/queryGrowthByCropAndDate?cropCode=010301&dateTime=${moment().format(
          "YYYY-MM-DD"
        )}`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        // this.cropListData = res.data.data;
        console.log(res.data.data);
        if (res.data.code == 500) {
          alert(res.data.message);
        } else {
          this.chooseCropTimeData = res.data.data.code;
          this.chooseCropTimeDataChange(res.data.data.code);
        }

        // this.list = res.data;
      });
    },
    chooseCropTimeDataChange(e) {
      // console.log(e);

      this.chooseCropTimeDataList = this.cropListData.find(item => {
        return item.code == e;
      });
      this.getDocList();
      console.log(this.chooseCropTimeDataList);
    },
    getCropTimeList() {
      this.$axios({
        method: "get",
        url:
          "http://120.79.183.250:3093/InterfaceServices/CropService/queryGrowthList?cropCode=010301",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        this.cropListData = res.data.data;
        this.getNewCropTime();
        // this.getDocList();
        // console.log(res.data);
        // this.list = res.data;
      });
    }
  }
};
</script>

<style>
.riceBodyBox {
  height: 150vh !important;
  width: 100vw !important;
  background-color: #111a30;
  padding: 0 10px;
}
.topBox {
  height: 200px;
  width: 100%;
  display: flex;
  /* background-color: aquamarine; */
  flex-wrap: wrap;
}
.topLeftBox {
  width: 50%;
  height: 200px;
  /* border: 1px solid red; */
  display: flex;
  align-items: center;
  justify-content: center;
}
.imgMyBox {
  height: 80px;
  width: 80px;
  background-color: antiquewhite;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0px 0px 8px 3px #e7be2b;
  border: 2px solid #e7be2b;
}
.imgNameBox {
  height: 80px;
  width: 80px;
  /* background-color: azure; */
  color: white;
  text-align: center;
  line-height: 80px;
  font-size: 22px;
}
.topRightBox {
  width: 50%;
  height: 200px;
  /* border: 1px solid red; */
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.temBox {
  width: 80%;
  height: 200px;
  /* background-color: #e7be2b; */
}
.myCHooseTimeBox {
  margin-top: 30px;
  height: 100px;
  width: 80%;
  /* background-color: #e7be2b; */
}
.cropTextBox {
  font-size: 12px;
  margin-top: 15px;
  color: white;
}
.temBoxItem {
  height: 25px;
  line-height: 25px;
  color: white;
  text-align: center;
}
.cropdesBox {
  height: auto;
  /* background-color: aqua; */
  width: 100%;
  background-color: #434d646b;
  padding: 10px;
  border-radius: 5px;
}
.el-input >>> .el-input__inner {
  background-color: #111a30;
  color: white;
}
.desTextBox {
  /* height: auto; */
  width: 100%;

  margin-top: 10px;
  color: white;
}
.desTextTitle {
  text-align: center;
  font-weight: 600;
}
.desTextDes {
  font-weight: 400;
  line-height: 30px;
  margin-top: 5px;
  /* font-size: 13px; */
}
.myNodty {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #323c57;
  width: 100vw;
  height: 40px;
  z-index: 9;
  color: #e7be2b;
  line-height: 40px;
  padding: 0 10px;
}
</style>